import { ref, onMounted, onUnmounted } from 'vue';

export function useMobile(breakpoint = 768) {
  const isMobile = ref(window.innerWidth < breakpoint);

  let timeout;
  const checkScreenSize = () => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      isMobile.value = window.innerWidth < breakpoint;
    }, 200); // Delay updates by 200ms to avoid excessive re-renders
  };

  onMounted(() => window.addEventListener('resize', checkScreenSize));
  onUnmounted(() => window.removeEventListener('resize', checkScreenSize));

  return { isMobile };
}
